module.exports = __webpack_public_path__ + "img/background.484cada8.svg";